import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  getCuratorProfileBySnsTitleService,
  getCuratorUserInfoService,
  getNicknameAvailableCountService,
  getNicknameRecommendationService,
  validateNicknameService,
} from '@musinsa/services-curator';

export const profileFactory = createQueryKeys('profile', {
  nicknameRecommendation: {
    queryKey: null,
    queryFn: getNicknameRecommendationService,
  },
  nicknameAvailableCount: {
    queryKey: null,
    queryFn: getNicknameAvailableCountService,
  },
  nicknameValidation: (nickname: string) => ({
    queryKey: [nickname],
    queryFn: () => validateNicknameService({ nickname }),
  }),
  userInfo: {
    queryKey: null,
    queryFn: getCuratorUserInfoService,
  },
  profileBySnsTitle: (snsTitle: string) => ({
    queryKey: [snsTitle],
    queryFn: () => getCuratorProfileBySnsTitleService({ snsTitle }),
  }),
});
